import React from 'react';
import styled from 'styled-components';

const negativeIcon = 'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/negative.svg';
import ContainerModal from '../ContainerModal';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  img {
    margin-bottom: 24px;
  }

  & .title {
    font-weight: 500;
    font-size: 24px;
    color: var(--color-gray-500);
    line-height: 32px;
    text-align: center;

    margin-bottom: 16px;
  }

  & .subtitle {
    font-weight: 500;
    font-size: 16px;
    color: var(--color-gray-400);
    line-height: 24px;
    text-align: center;
  }
`;

export type ModalProductNotCoveredProps = {
  visible: boolean;
  onClose: () => void;
};

export const ModalProductNotCovered: React.FC<ModalProductNotCoveredProps> = ({ visible, onClose }) => {
  return (
    <ContainerModal visible={visible} onClose={onClose}>
      <Container>
        <img src={negativeIcon} alt="negative" />
        <h3 className="title">Produto não coberto</h3>
        <p className="subtitle">O método de pagamento selecionado não cobre o produto.</p>
      </Container>
    </ContainerModal>
  );
};
